import script from "./Customers.vue?vue&type=script&setup=true&lang=js"
export * from "./Customers.vue?vue&type=script&setup=true&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=4d7b7e2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7b7e2d"]])

export default __exports__